var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3999 14.652V7.23798C4.3999 5.24017 4.3999 4.24127 5.01498 3.62064C5.63005 3 6.62 3 8.5999 3H11.3999C13.3798 3 14.3697 3 14.9848 3.62064C15.5999 4.24127 15.5999 5.24017 15.5999 7.23798V14.652C15.5999 15.7102 15.5999 16.2393 15.2765 16.4475C14.7481 16.7879 13.9312 16.0742 13.5203 15.8151C13.1808 15.601 13.0111 15.4939 12.8226 15.4878C12.6191 15.4811 12.4463 15.5837 12.0795 15.8151L10.7419 16.6587C10.381 16.8862 10.2007 17 9.99989 17C9.79913 17 9.61874 16.8862 9.25789 16.6587L7.92029 15.8151C7.5808 15.601 7.41106 15.4939 7.22267 15.4878C7.0191 15.4811 6.84635 15.5837 6.47951 15.8151C6.06866 16.0742 5.25171 16.7879 4.72327 16.4475C4.3999 16.2393 4.3999 15.7102 4.3999 14.652Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29995 9.30005H7.19995",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 6.5H7.19995",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.84a9f92a8fc1864f4b0d4a2412ee7045.svg";
export { ForwardRef as ReactComponent };